// extracted by mini-css-extract-plugin
export default {"wrapper":"SignIn_wrapper__uU--y","image":"SignIn_image__M+7rD","content":"SignIn_content__V3Ddk"};